import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react'
import { Rnd } from 'react-rnd';
interface DragableWindowProps {
    children: JSX.Element;
    headerIcon?: JSX.Element;
    headerContentLeft?: JSX.Element;
    headerContentRight?: JSX.Element;
    title: string;
    width?: number;
    minWidth?: number;
    height?: number;
    minHeight?: number;
    sizeChanged?: (width: number, height: number) => void;
    onCloseClicked?: () => void;
}

export default function DragableWindow(props: DragableWindowProps) {
    const { children, title, height, width, sizeChanged, onCloseClicked, headerIcon, headerContentLeft, headerContentRight, minWidth, minHeight } = props;
    const [xLoc, setXLoc] = React.useState(80);
    const [yLoc, setYLoc] = React.useState(80);
    const defaultLoc = 70;
    const style = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "solid 1px #ddd",
        background: 'rgba(255, 255, 255, 0.55)',
        zIndex: 10,

    };
    return (
        <Rnd
            minWidth={minWidth ?? 320}
            minHeight={minHeight ?? 240}
            onResizeStop={(e, direction, ref, delta, position) => {
                console.log(delta.height);
                console.log(delta.width);
                if (position.x > defaultLoc)
                    setXLoc(position.x);
                else setXLoc(defaultLoc);
                if (position.y > defaultLoc)
                    setYLoc(position.y);
                else setYLoc(defaultLoc);
                if (sizeChanged)
                    sizeChanged(delta.width, delta.height);
            }}
            position={{ x: xLoc, y: yLoc }}
            onDragStop={(e, d) => {
                if (d.x > defaultLoc)
                    setXLoc(d.x);
                else setXLoc(defaultLoc);
                if (d.y > defaultLoc)
                    setYLoc(d.y);
                else setYLoc(defaultLoc);
                // if (!(d.x > 55 && d.y > 55)) {
                //    se
                // }else{
                //     setXLoc(d.x);
                //     setYLoc(d.y);
                // }
                // console.log(e, d);
            }}
            style={style}
            default={{
                x: defaultLoc,
                y: defaultLoc,

                width: width ?? 460,
                height: height ?? 300,

            }}
        >
            <div style={{ width: "100%", height: '100%' }}>
                <div style={{ height: "64px", background: "#f5f5f5", border: '1px solid #C3C3C3', margin: '16px', display: 'flex', justifyContent: 'space-between', width: 'calc(100% - 32px)' }} >
                    <div style={{ marginLeft: '10px', marginTop: '4px', fontWeight: 'bold', lineHeight: '52px', display: 'flex' }}>
                        <div style={{ marginTop: '8px', marginLeft: '8px', marginRight: '12px', width: '40px' }}>{headerIcon}</div>
                        <div style={{ marginLeft: '12px' }}>{title}</div>
                        <div style={{ marginLeft: '32px' }}>{headerContentLeft}</div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ marginRight: '12px' }}>{headerContentRight}</div>
                        <IconButton sx={{ minWidth: '52px' }} onClick={() => {
                            if (onCloseClicked)
                                onCloseClicked();
                        }}>
                            <Close />
                        </IconButton>
                    </div>
                </div>
                <div style={{ width: "100%", height: '100%', cursor: 'default' }} onMouseDown={(e) => {
                    // e.preventDefault();
                    // e.stopPropagation();
                }}>{children}</div>

            </div>
        </Rnd>
    )
}
